import { DataGrid } from 'components/shared/data/DataGrid/DataGrid';
import { ActionHandlers, BrowserProps } from 'components/templates/Browser/Browser.types';
import { templatesBrowserColumns } from 'components/templates/Browser/columns.config';
import React, { FC } from 'react';
import { downloadTemplateById } from 'utils/files/downloadTemplate';

export const Browser: FC<BrowserProps> = (props) => {
  const actionHandlers: ActionHandlers = {
    preview: (templateId: string) => downloadTemplateById(templateId),
  };

  return (
    <DataGrid
      data={props.templates}
      isLoading={props.isLoading}
      columns={templatesBrowserColumns(actionHandlers)}
      loadingMessage={'TEMPLATES.BROWSER.LOADING'}
      noResultsMessage={'TEMPLATES.BROWSER.NO_RESULTS'}
    />
  );
};
